module.exports = __webpack_public_path__ + "img/share_tip.2aeaabba.png";